import { render, staticRenderFns } from "./ArtistLibrary.vue?vue&type=template&id=6c727aa4"
import script from "./ArtistLibrary.vue?vue&type=script&lang=ts"
export * from "./ArtistLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports